// src/services/parentService.js
import http from "../api/apiClient"; // ✅ gebruik de centrale client

export const resetPassword = async (parentId) => {
  return await http.post(`/parents/${parentId}/reset-password`, {});
  // lege body is prima, headers worden automatisch gezet
};

export const resetAccount = async (parentId) => {
  return await http.post(`/parents/${parentId}/reset-account`);
};